import APIService from "./APIService";

class ProductService extends APIService {
  add = async (
    name: string,
    description: string,
    category_id: string,
    group_id: string,
    product_units: any = [],
    image: {},
    tmp: string
  ) => {
    const result = await this.post(
      { name, description, category_id, group_id, product_units, image, tmp },
      "products"
    );
    return result ? result.data : null;
  };

  search = async (
    search: string = "",
    page: number = 1,
    limit: number = 10,
    sort: string
  ) => {
    const result = await this.get(
      "products/search?generic=" +
        search +
        "&page=" +
        page +
        "&limit=" +
        limit +
        "&sort=" +
        sort
    );
    return result ? result.data : null;
  };

  getProduct = async (id: string) => {
    const result = await this.get("products/" + id);
    return result ? result.data : null;
  };

  edit = async (
    name: string,
    description: string,
    category_id: string,
    group_id: string,
    product_units: any = [],
    image: {},
    tmp: string,
    id: string
  ) => {
    const result = await this.put(
      { name, description, category_id, group_id, product_units, image, tmp },
      "products/" + id
    );
    return result ? result.data : null;
  };

  delete = async (id: string) => {
    const result = await this.remove("products/" + id);
    return result ? result.data : null;
  };

  getSelect = async () => {
    const result = await this.get("products/select");
    return result ? result.data : null;
  };

  upload = () => {
    return this.baseURL + "/s3/upload?tmp=";
  };
}

export default ProductService;
